export const SESSION_EXPIRED_EVENT = "rubby:session-expired";

/**
 * Path to send the user after a failed token refresh.
 * Returns null when they are already on /auth so we do not loop.
 */
export function buildAuthRedirectPath(pathname, search = "") {
  if (typeof pathname !== "string" || pathname.startsWith("/auth")) {
    return null;
  }
  const redirect = `${pathname}${search ?? ""}`;
  if (!redirect || redirect === "/") return "/auth";
  return `/auth?redirect=${encodeURIComponent(redirect)}`;
}
